import { render, staticRenderFns } from "./_PASSPORT_FACE.vue?vue&type=template&id=f42034a4&"
import script from "./_PASSPORT_FACE.vue?vue&type=script&lang=js&"
export * from "./_PASSPORT_FACE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports